package uz.ferro.erp.model

import kotlinx.serialization.Serializable

@Serializable
data class DataFile(
    val id: Int,
    val name: String,
    val url: String
)